import { getMeetingInsightsStore } from '../store/store';
import { mutator } from 'satcheljs';
import {
    tryAddToPendingServiceQueue,
    tryRemoveFromPendingServiceQueue,
} from '../actions/internalActions';
import isFetchMeetingInsightsServicePending from '../selectors/isFetchMeetingInsightsServicePending';
import { getInsightsMapKey } from '../helpers/getInsightsMapKey';

mutator(tryAddToPendingServiceQueue, actionMessage => {
    const { meetingId, dataFetchSource } = actionMessage;
    if (isFetchMeetingInsightsServicePending(meetingId, dataFetchSource)) {
        return;
    }

    getMeetingInsightsStore().pendingServiceQueue.push(
        getInsightsMapKey(meetingId, dataFetchSource)
    );
});

mutator(tryRemoveFromPendingServiceQueue, actionMessage => {
    const { meetingId, dataFetchSource } = actionMessage;

    getMeetingInsightsStore().pendingServiceQueue.remove(
        getInsightsMapKey(meetingId, dataFetchSource)
    );
});
